import  { useState, useEffect } from 'react'; 
import { useSelector, useDispatch } from 'react-redux'; 
import { useNavigate } from 'react-router-dom';
import { FaHeart, FaShoppingBag } from 'react-icons/fa';
import CardContainer from '../components/CardContainer'; 
import './Wishlist.css'; 
import { fetchUserWishlist } from '../redux/wishlistActions'; 

const Wishlist = () => { 
    // Redux hooks and state 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const wishlistItems = useSelector(state => state.wishlist.items); 
    const [loading, setLoading] = useState(true);

    // Fetch wishlist data on component mount
    useEffect(() => {
        // Dispatch action to fetch user's wishlist
        dispatch(fetchUserWishlist())
            .catch(error => console.error("Failed to load wishlist data:", error))
            .finally(() => setLoading(false));
            
    }, [dispatch]);

    return ( 
        <div className='wishlist-container'>
            <div className="wishlist-header">
                <div className="wishlist-title-section">
                    <div className="wishlist-icon-wrapper">
                        <FaHeart className="wishlist-header-icon" />
                    </div>
                    <div>
                        <h1 className="wishlist-main-title">My Wishlist</h1>
                        <p className="wishlist-subtitle">Save your favorite items for later</p>
                    </div>
                </div>
                {!loading && wishlistItems.length > 0 && (
                    <div className="wishlist-count-badge">
                        {wishlistItems.length} {wishlistItems.length === 1 ? 'item' : 'items'}
                    </div>
                )}
            </div>

            {!loading && wishlistItems.length === 0 ? (
                <div className="wishlist-empty-state">
                    <div className="empty-state-icon-circle">
                        <FaHeart className="empty-heart-icon" />
                    </div>
                    <h2 className="empty-state-title">Your Wishlist is Empty</h2>
                    <p className="empty-state-text">
                        Start adding items you love to your wishlist.
                        <br />They'll be saved here for you to view anytime!
                    </p>
                    <button 
                        className="btn-browse-products"
                        onClick={() => navigate('/products')}
                    >
                        <FaShoppingBag style={{ marginRight: '8px' }} />
                        Browse Products
                    </button>
                </div>
            ) : (
                <CardContainer 
                    posts={wishlistItems} 
                    loading={loading} 
                    title="" 
                    isWishlistPage={true} 
                /> 
            )}
        </div> 
    ); 
}; 

export default Wishlist;